module.exports = __webpack_public_path__ + "static/media/Husqvarna.c7297480.svg";